import * as Yup from 'yup';

const sharePortfolioSchema = Yup.object().shape({
  users: Yup.array()
    .min(1, 'Check at least one user.')
    .required(),
  message: Yup.string()
    .min(1)
    .required(),
});

export { sharePortfolioSchema };
